"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var StyledTextField = (0, _styles.styled)(_material.TextField)({
  "& label.Mui-focused": {
    color: "#c3c3c3"
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#c3c3c3"
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#c3c3c3"
    },
    "&:hover fieldset": {
      borderColor: "#c3c3c3"
    },
    "&.Mui-focused fieldset": {
      borderColor: "#c3c3c3"
    }
  }
});
var _default = StyledTextField;
exports.default = _default;